import { render, staticRenderFns } from "./AllPolicy.vue?vue&type=template&id=05a7b351&scoped=true"
import script from "./AllPolicy.vue?vue&type=script&lang=js"
export * from "./AllPolicy.vue?vue&type=script&lang=js"
import style0 from "./AllPolicy.vue?vue&type=style&index=0&id=05a7b351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a7b351",
  null
  
)

export default component.exports